// AuthCallback.jsx
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { initNewToken, setUserRequests } from '../../services/apiClient';

import UniversalModall, { useModal } from '../../components/AlertModal/UniversalModal';

import { userService } from '../../services/userService';
import { handleChange } from '../../components/helpers/latencyfunc';

import AuthCallbackWait from './oauthcallback';


const textMsg = `Система не отримала вашу електронну пошту або вона не збігається з поштою, яка раніше використовувалась. Перевірте, чи вказана електронна пошта у Модулі авторизації та чи збігається вона з поштою вашого профілю в Системі. Після цього повторіть вхід. Якщо проблема не зникає — зверніться до технічної підтримки. Перейти до модулю авторизації https://wso2id.kyivcity.gov.ua ?`;

const redirectErrorAuth = `https://wso2id.kyivcity.gov.ua`;


function AuthCallback({ onAuthSuccess }) {
  const location = useLocation();
  const navigate = useNavigate();


  const {
        modalProps,
        alert,
        confirm,
        prompt,
        success,
        error,
        warning,
        Modal
    } = useModal();
  
  
  const handleError = async () => {

      const result = await confirm(textMsg, 'Налаштування профілю користувача');

      const isResult = result?.type === "primary";

      if(isResult) return  window.location.href = redirectErrorAuth;

      return navigate('/');
      
  };

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const error = params.get('error');

      if (error) {
          console.error('OAuth error:', error);
          navigate('/login?error=auth_failed');
          return;
      };

      if(!code) return;

      const tokGet = await initNewToken(code);

      if(!tokGet) return;

      

      if(tokGet?.token) {
          onAuthSuccess(tokGet);
          const requests = tokGet?.requests || [];
          if(requests.length > 0) setUserRequests(requests.length);
          setTimeout(()=>navigate(userService.firstPage(requests.length),  { replace: true }), 500);
      } else {
          return handleError();
      }

    };

    handleCallback();
  }, [ location ]);

  return <div >
    <AuthCallbackWait />
  <Modal />
  </div>;
}

export default AuthCallback;